import {
    React,
    useState,
    useEffect,
    Typography,
    Grid2,
    Tabs,
    Tab,
    Box,
    IconButton,
    Divider,
    AppLayout,
    ProposalFeeStageNotesComments,
    ProposalFeeStageSummary,
    ProposalFeeStageCommercialDates,
    ProposalFeeStageSubStage,
    formatNumberWithCommas,
    useLocation
} from "../../../utils/globalImports";

import {
    useNavigate,
    useParams,
    ArrowBackIosIcon,
    useApi,
    UserType,
    FeeStageStatus,
    Toaster,
    validationMessages,
    CustomButton,
    CustomTextField,
    CustomDropdown,
    CustomMultiSelectDropdown,
    CustomRadioButton,
    FilterCard,
    ProposalFeeStageInstructionLog
} from '../../../utils/globalImports';

import {
    ApiResponse
} from '../../../services/apiService';
import { headingStyles } from "../../../assets/styles/CommonStyles";

interface ProposalFeeStage {
    id?: number;
    projectId?: number;
    projectNumber: string;
    projectName: string;
    proposalId?: number;
    proposalNumber: string;
    proposalName: string;
    proposalStageId?: number;
    description: string;
    unitPrice: number;
    unitPricePer: string;
    status?: number;
    completionNotes: string;
    createdId?: number;
    updatedId?: number;
    Status?: string;
    quantity?: number;
    proposalValue?: number;
    thirdPartyCost?: number;
    completedbyIndia: boolean;
    isDisbursement: boolean;
    isThirdPartyCost: boolean;
    feeStageTagIds: [];
    tplid: number;
    stageAreaID: number;
    stageStatus?: number;
    stageStatusDescription?: string;
    stageAreaDescription?: string;
    tplDescription?: string;
    feeStageTagDescriptions?: [];
    categoryId?: number;
    categoryName?: string;
    subCategoryId?: number;
    subCategoryName?: string;
}

const tabStyles = {
    textTransform: "none",
    fontWeight: 500,
    flex: 1, // Ensures even spacing
    minWidth: "auto",
    maxWidth: "100%",
    fontSize: "16px",
    color: "#1e66ab", // Customizable text color
    borderBottom: "2px solid #d3d3d3", // Underline for all tabs
    "&.Mui-selected": {
        backgroundColor: "#1e66ab", // Customizable active tab color
        color: "white",
        borderRadius: "8px 8px 0 0",
    },
};

interface Option {
    value: string | number;
    text: string;
}

const ProposalEditFeeStage: React.FC = () => {

    const { execute } = useApi();
    const navigate = useNavigate();
    const location = useLocation();
    const [tagOptions, setTagOptions] = useState<Option[]>([]);
    const [areaOptions, setAreaOptions] = useState<Option[]>([]);
    const [tplOptions, setTPLOptions] = useState<Option[]>([]);
    const [categoryOptions, setcategoryOptions] = useState<Option[]>([]);
    const [subCategoryOptions, setSubCategoryOptions] = useState<Option[]>([]);
    const [statusOptions, setStatusOptions] = useState<Option[]>([]);
    const [feeStageData, setFeeStageData] = useState<ProposalFeeStage | null>(null);
    const [toast, setToast] = useState({ open: false, message: "", type: "success" });
    const [activeTab, setActiveTab] = React.useState(1);


    const delay = (ms: number | undefined) => new Promise(resolve => setTimeout(resolve, ms));

    const { feeStageId } = useParams<{ feeStageId?: string }>(); // Get feeStageId from URL
    const { readonly } = useParams<{ readonly?: string }>(); // Get feeStageId from URL
    const isReadOnly = readonly === 'true';

    const userId = Number(localStorage.getItem("userId"));

    const [formData, setFormData] = useState({
        projectNumber: '',
        projectName: '',
        proposalNumber: '',
        proposalName: '',
        feeStageName: '',
        feeStageTPL: -1,
        unitPrice: 0,
        unitDescription: '',
        quantity: 0,
        feeStageValue: 0,
        thirdPartyCost: 0,
        feeStageArea: -1,
        feeStageTags: [] as number[],
        isIndia: true,
        isDisbursement: true,
        isThirdPartyCost: true,
        status: true,
        termsNotesComments: '',
        feeStageStaus: -1,
        stageStatusDescription: '',
        stageAreaDescription: '',
        tplDescription: '',
        feeStageTagDescriptions: [] as string[],
        categoryId: -1,
        categoryName: '',
        subCategoryId: -1,
        subCategoryName: '',
    });

    const [errors, setErrors] = useState({
        feeStageName: '',
        feeStageTPL: '',
        unitPrice: '',
        unitDescription: '',
        quantity: '',
        feeStageArea: '',
        thirdPartyCost: ''
    });

    useEffect(() => {
        if (feeStageId) {
            fetchFeeStage(); // Fetch FeeStage
            fetchTags(); // Fetch FeeSatge Tags 
            fetchArea(); // Fetch FeeSatge Areas 
            fetchPersonnel(); // Fetch TPL
            fetchStatusType(); // Fetch Status


            setErrors({
                feeStageName: '',
                feeStageTPL: '',
                unitPrice: '',
                unitDescription: '',
                quantity: '',
                feeStageArea: '',
                thirdPartyCost: '',
            });
        }

    }, [feeStageId])
    const fromPage = location.state?.from;

    // Fetch feeStage
    const fetchFeeStage = async () => {
        const { data } = await execute<ProposalFeeStage>('get', `/Proposal/feeStages/${feeStageId}`);
        setFeeStageData(data)
        console.log(data);
        fetchCategory(data?.projectId!); // Fetch Category 
        if (data) {
            // Update formData with fetched data
            const isProposalInstructed =
                data.proposalStageId === 6 &&
                (data.stageStatus === null || data.stageStatus === undefined);
            setFormData({
                projectNumber: data.projectNumber || '',
                projectName: data.projectName || '',
                proposalNumber: data.proposalNumber || '',
                proposalName: data.proposalName || '',
                feeStageName: data.description || '',
                feeStageTPL: data.tplid || -1,
                unitPrice: data.unitPrice || 0,
                unitDescription: data.unitPricePer || '',
                quantity: data.quantity || 0,
                feeStageValue: data.proposalValue || 0,
                thirdPartyCost: data.thirdPartyCost || 0,
                feeStageArea: data.stageAreaID || -1,
                feeStageTags: data.feeStageTagIds,
                isIndia: data.completedbyIndia,
                isDisbursement: data.isDisbursement,
                isThirdPartyCost: data.isThirdPartyCost,
                status: data.status === 1 ? true : false,
                termsNotesComments: data.completionNotes || '',
                //feeStageStaus: data.stageStatus || -1,
                //stageStatusDescription: data.stageStatusDescription || 'null',
                feeStageStaus: isProposalInstructed
                    ? 1
                    : data.stageStatus || -1,

                stageStatusDescription: isProposalInstructed
                    ? FeeStageStatus[1]
                    : data.stageStatusDescription || '',
                stageAreaDescription: data.stageAreaDescription || '',
                tplDescription: data.tplDescription || '',
                feeStageTagDescriptions: data.feeStageTagDescriptions || [],
                categoryId: data.categoryId || -1,
                categoryName: data.categoryName || 'null',
                subCategoryId: data.subCategoryId || -1,
                subCategoryName: data.subCategoryName || 'null',
            });
            // setFeeStageID(data.feeStageId)

            if (data.categoryId != null) fetchSubCategory(data.categoryId)
        }
        else {
            navigate('/404');  // Redirect to a Not Found page
        }
    };

    // fetch feeStageTags
    const fetchTags = async () => {
        const { data } = await execute('get', '/Lookup/GetAllProposalTags');
        if (data && Array.isArray(data)) {
            const tagsOptions = data
                .filter(tag => tag.status) // Filter for active tags
                .map(tag => ({
                    value: tag.proposalTagId,
                    text: tag.proposalTag
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
            setTagOptions(tagsOptions);
        }
    };

    // fetch feestageArea
    const fetchArea = async () => {
        const { data } = await execute('get', '/LookUp/GetFeeStageAreaNames');
        if (data && Array.isArray(data)) {
            const areaOptions = data
                .filter(area => area.status) // Filter for active areas
                .map(area => ({
                    value: area.feeStageAreaNameId,
                    text: area.feeStageAreaName
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
            setAreaOptions(areaOptions);
        }
    };

    // fetch TPL
    const fetchPersonnel = async () => {
        const { data } = await execute('get', '/Lookup/GetAllPersonnel');
        if (data && Array.isArray(data)) {
            const tplOptions = data
                .filter(tpl => tpl.status && tpl.userTypes.includes(UserType.TechnicalProjectLead)) // Filter for active TPL
                .map(tpl => ({
                    value: tpl.personnelId,
                    text: `${tpl.firstName} ${tpl.lastName}`
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
            setTPLOptions(tplOptions);
        }
    };

    // fetch Category
    const fetchCategory = async (id: number) => {
        const { data } = await execute('get', `/Category/Project/${id}`);
        if (data && Array.isArray(data)) {
            const categoryOptions = data
                .map(category => ({
                    value: category.id,
                    text: category.description
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
            setcategoryOptions(categoryOptions);
        }
    };

    // fetch SubCategory
    const fetchSubCategory = async (id: number) => {
        const { data } = await execute('get', `/SubCategory/Category/${id}`);
        if (data && Array.isArray(data)) {
            const subCategoryOptions = data
                .map(sub => ({
                    value: sub.id,
                    text: sub.description
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting;;
            setSubCategoryOptions(subCategoryOptions);
        }
    };

    // fetch FeeStage Status
    const fetchStatusType = async () => {
        const categoryOptions = Object.entries(FeeStageStatus).map(([id, description]) => ({
            value: Number(id),  // Ensure `id` exists in the response
            text: description, // Ensure `name` exists in the response
        }))
        setStatusOptions(categoryOptions);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;

        if (name === "thirdPartyCost") {
            const rawValue = value.replace(/,/g, ''); // remove commas
            const newCost = Number(rawValue) || 0;

            setFormData((prev) => ({
                ...prev,
                thirdPartyCost: newCost, // save numeric
            }));
            return; // stop normal handling
        }
        // If the "No" radio button is selected, reset thirdPartyCost to 0.0
        if (name === "isThirdPartyCost" && value === "false") {
            setFormData(prev => ({
                ...prev,
                thirdPartyCost: 0.0,
            }));
        }

        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : type === "radio" ? value === "true" : value,
        }));
    };


    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };


    // validate feestage form field
    const validate = () => {
        let isValid = true;
        const errors = {
            feeStageName: '',
            feeStageTPL: '',
            unitPrice: '',
            unitDescription: '',
            quantity: '',
            feeStageArea: '',
            thirdPartyCost: '',
        };

        if (!formData.feeStageName || !formData.feeStageName.trim()) {
            errors.feeStageName = validationMessages.common_required("Fee stage name");
            isValid = false;
        }
        else if (formData.feeStageName.length > 100) {
            errors.feeStageName = validationMessages.common_maxLength("Fee stage name", 100);
            isValid = false;
        }
        else if (/[^a-zA-Z\s]/.test(formData.feeStageName)) {
            errors.feeStageName = validationMessages.common_invalidString("Fee stage name")
            isValid = false;
        }


        if (formData.feeStageTPL === -1) {
            errors.feeStageTPL = validationMessages.common_required("Fee stage tpl");
            isValid = false;
        }

        if (!formData.unitPrice) {
            errors.unitPrice = validationMessages.common_required("Unit price");
            isValid = false;
        }
        // else if (Number(formData.unitPrice) <= 0) {
        //     errors.unitPrice = validationMessages.common_negativeNumber("Unit price");
        //     isValid = false;
        // }

        if (!formData.unitDescription) {
            errors.unitDescription = validationMessages.common_required("Unit Description");
            isValid = false;
        }
        else if (/[^a-zA-Z\s]/.test(formData.unitDescription)) {
            errors.unitDescription = validationMessages.common_invalidString("Unit Description")
            isValid = false;
        }

        if (!formData.quantity) {
            errors.quantity = validationMessages.common_required("Quantity");
            isValid = false;
        }
        else if (Number(formData.quantity) <= 0) {
            errors.quantity = validationMessages.common_negativeNumber("Quantity");
            isValid = false;
        }

        if (formData.feeStageArea === -1) {
            errors.feeStageArea = validationMessages.common_required("Business Plan Area");
            isValid = false;
        }
        if (formData.isThirdPartyCost) {
            const thirdPartyCost = Number(formData.thirdPartyCost);
            const feeStageValue = Number(formData.feeStageValue);

            if (thirdPartyCost <= 0) {
                errors.thirdPartyCost = validationMessages.common_negativeNumber("Third Party Cost must be greater than 0");
                isValid = false;
            }
            // else if (thirdPartyCost > feeStageValue) {
            //     errors.thirdPartyCost = validationMessages.common_invalidDate("Third Party Cost must be less than Fee Stage Value");
            //     isValid = false;
            // }
        }


        setErrors(errors);
        return isValid;
    };


    const handleFeestage = async () => {

        if (validate()) {
            let response: ApiResponse<any>;

            if (feeStageData) {
                if (formData.feeStageValue < 0) {
                    formData.thirdPartyCost = 0; // or feeStageValue, or abs(feeStageValue)
                }
                const updatedProposalFeeStages = {
                    id: feeStageData.id,
                    description: formData.feeStageName,
                    tplid: formData.feeStageTPL,
                    unitPrice: formData.unitPrice.toFixed(2),
                    unitPricePer: formData.unitDescription,
                    quantity: formData.quantity.toFixed(2),
                    stageAreaID: formData.feeStageArea,
                    feeStageTagIds: formData.feeStageTags,
                    completedbyIndia: formData.isIndia,
                    isDisbursement: formData.isDisbursement,
                    isThirdPartyCost: formData.isThirdPartyCost,
                    thirdPartyCost: formData.thirdPartyCost,
                    status: formData.status ? 1 : 0,
                    completionNotes: formData.termsNotesComments,
                    stageStatus: formData.feeStageStaus > 0 ? formData.feeStageStaus : null,
                    stageStatusDescription: formData.stageStatusDescription,
                    stageAreaDescription: formData.stageAreaDescription,
                    tplDescription: formData.tplDescription,
                    feeStageTagDescriptions: formData.feeStageTagDescriptions,
                    categoryId: formData.categoryId > 0 ? formData.categoryId : null,
                    categoryName: formData.categoryName,
                    subCategoryId: formData.subCategoryId > 0 ? formData.subCategoryId : null,
                    subCategoryName: formData.subCategoryName,
                    updatedId: userId
                };

                response = await execute('put', '/Proposal/framework/UpdatefeeStage', updatedProposalFeeStages);

                if (response!) {
                    if (response.error) {
                        // If there's an error in the response, display the error message
                        setToast({ open: true, message: response.error, type: "error" });
                    } else {
                        // If the response is successful, display the success message
                        setToast({ open: true, message: response.data, type: "success" });
                        await delay(1500);
                    }
                }
            }
        }
    }

    const handleBacktoFeeStage = () => {
        if (fromPage) {
            navigate(fromPage);
        }
        else {
            navigate(`/proposal/add-proposal/${feeStageData?.projectId}/${feeStageData?.proposalId}/${feeStageData?.projectName}`, {
                state: { fromTab: 7 },
            });
        }

    }

    return (
        <AppLayout>

            <Grid2 container spacing={1} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Grid2 size={{ xs: 12, md: 6, lg: 8 }} sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton sx={{ width: '40px', height: '40px', backgroundColor: 'transparent' }} onClick={handleBacktoFeeStage} >
                        <ArrowBackIosIcon sx={{ color: '#1e66ab', fontSize: '15px' }} />
                    </IconButton>

                    <Typography variant="h6" noWrap sx={headingStyles}>
                        Edit Fee Stage
                    </Typography>
                </Grid2>


                <Grid2 size={{ xs: 12, md: 3, lg: 2 }}>
                    <CustomButton
                        capsule
                        type="button" // ✅ Add this line
                        sx={{
                            mt: 0,
                            mb: 2,
                            textTransform: 'none',
                            whiteSpace: 'nowrap',
                        }}
                        onClick={handleFeestage}
                    >
                        Update Fee Stage
                    </CustomButton>
                </Grid2>
            </Grid2>
            <Box sx={{ display: "flex", flex: 1, flexDirection: "column", minHeight: 0}}>
                <Tabs style={{ width: "100%", fontSize: "16px", position: "relative", left: "0%",  }}
                    value={activeTab}
                    onChange={handleChangeTab}
                    aria-label="secondary tabs example"
                >
                    <Tab value={1} label="General" sx={tabStyles} />
                    <Tab value={2} label="Summary" sx={tabStyles} />
                    {/* <Tab value={3} label="Forecast" sx={tabStyles} /> */}
                    <Tab value={4} label="Commercial dates" sx={tabStyles} />
                    <Tab value={5} label="Notes/Comments" sx={tabStyles} />
                    <Tab value={6} label="Fee stage log" sx={tabStyles} />
                    <Tab value={7} label="Sub Stage" sx={tabStyles} />

                </Tabs>

                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    // height: "calc(100vh - 190px)",
                    paddingRight: 2,
                    paddingTop: 2
                }}>


                    {
                        (() => {
                            switch (activeTab) {
                                case 1:
                                    return (
                                        <>
                                            <Grid2 container spacing={2} sx={{ backgroundColor: '#f7faff',border: '1px solid #e0eaf6', borderRadius: '14px', padding: 1.5, marginBottom: 1 }}>
                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomTextField
                                                        label="Project Number"
                                                        name="projectNumber"
                                                        value={formData.projectNumber}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff"}}
                                                        disable
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomTextField
                                                        label="Project Name"
                                                        name="projectName"
                                                        value={formData.projectName}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        disable
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomTextField
                                                        label="Proposal Number"
                                                        name="proposalNumber"
                                                        value={formData.proposalNumber}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        disable
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomTextField
                                                        label="Proposal Name"
                                                        name="proposalName"
                                                        value={formData.proposalName}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        disable
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomTextField
                                                        label="Fee Stage Name"
                                                        name="feeStageName"
                                                        value={formData.feeStageName}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        required={true}
                                                        disable={isReadOnly}
                                                    />
                                                    {errors.feeStageName && (
                                                        <Typography className="validationMessage" role="alert">
                                                            {errors.feeStageName}
                                                        </Typography>
                                                    )}
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomDropdown
                                                        value={formData.feeStageTPL}
                                                        onChange={(event) => {
                                                            const selectedId = Number(event.target.value);
                                                            const selectedOption = tplOptions.find(option => option.value === selectedId)
                                                            setFormData({
                                                                ...formData,
                                                                feeStageTPL: selectedId,
                                                                tplDescription: selectedOption?.text!
                                                            })
                                                        }}
                                                        label="Fee Stage TPL"
                                                        options={tplOptions}
                                                        requiredLabel={true}
                                                        //disable={isReadOnly}
                                                        sx={{ mb: 1, height: '35px', backgroundColor: "#fff" }}
                                                    />
                                                    {errors.feeStageTPL && (
                                                        <Typography className="validationMessage" role="alert">
                                                            {errors.feeStageTPL}
                                                        </Typography>
                                                    )}
                                                </Grid2>


                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <CustomTextField
                                                        label="Unit Price"
                                                        name="unitPrice"
                                                        type="text"
                                                        value={formData.unitPrice ? formatNumberWithCommas(formData.unitPrice) : ''}
                                                        onChange={(event) => {
                                                            //const newUnitPrice = parseFloat(event.target.value) || 0;
                                                            const rawValue = event.target.value.replace(/,/g, '');
                                                            const newUnitPrice = Number(rawValue) || 0;
                                                            const isSelectedThridparty = (newUnitPrice < 0);
                                                            setFormData({
                                                                ...formData,
                                                                unitPrice: newUnitPrice,
                                                                feeStageValue: newUnitPrice * formData.quantity,
                                                                isThirdPartyCost: !isSelectedThridparty
                                                            });
                                                        }}
                                                        sx={{ mb: 1, backgroundColor: "#fff"}}
                                                        required={true}
                                                        disable={isReadOnly}
                                                    />
                                                    {errors.unitPrice && (
                                                        <Typography className="validationMessage" role="alert">
                                                            {errors.unitPrice}
                                                        </Typography>
                                                    )}
                                                </Grid2>

                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <CustomTextField
                                                        label="Unit Description"
                                                        name="unitDescription"
                                                        value={formData.unitDescription}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        required={true}
                                                        disable={isReadOnly}
                                                    />
                                                    {errors.unitDescription && (
                                                        <Typography className="validationMessage" role="alert">
                                                            {errors.unitDescription}
                                                        </Typography>
                                                    )}
                                                </Grid2>

                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <CustomTextField
                                                        label="Quantity"
                                                        name="quantity"
                                                        type="text"
                                                        value={formData.quantity ? formatNumberWithCommas(formData.quantity) : ''}
                                                        onChange={(event) => {
                                                            // Remove commas and parse the number
                                                            const rawValue = event.target.value.replace(/,/g, '');
                                                            const newQuantity = Number(rawValue) || 0;

                                                            setFormData({
                                                                ...formData,
                                                                quantity: newQuantity,
                                                                feeStageValue: newQuantity * formData.unitPrice,
                                                            });
                                                        }}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        required={true}
                                                        disable={isReadOnly}
                                                    />
                                                    {errors.quantity && (
                                                        <Typography className="validationMessage" role="alert">
                                                            {errors.quantity}
                                                        </Typography>
                                                    )}
                                                </Grid2>

                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <CustomTextField
                                                        label="Fee Stage Value"
                                                        name="feeStageValue"
                                                        value={formData.feeStageValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        disable
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomDropdown
                                                        value={formData.feeStageArea}
                                                        onChange={(event) => {
                                                            const selectedId = Number(event.target.value);
                                                            if (selectedId === -1) {
                                                                // Reset formData for placeholder
                                                                setFormData({
                                                                    ...formData,
                                                                    feeStageArea: -1,
                                                                    stageAreaDescription: ""
                                                                });
                                                                return;
                                                            }
                                                            const selectedOption = areaOptions.find(option => option.value === selectedId)
                                                            setFormData({
                                                                ...formData,
                                                                feeStageArea: selectedId,
                                                                stageAreaDescription: selectedOption?.text!
                                                            })
                                                        }}
                                                        label="Business Plan Area"
                                                        options={areaOptions}
                                                        requiredLabel={true}
                                                        sx={{ mb: 1, height: '35px', backgroundColor: "#fff" }}
                                                    // disable={isReadOnly}
                                                    />
                                                    {errors.feeStageArea && (
                                                        <Typography className="validationMessage" role="alert">
                                                            {errors.feeStageArea}
                                                        </Typography>
                                                    )}
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomMultiSelectDropdown
                                                        selectedValues={formData.feeStageTags}
                                                        onChange={(event) => {
                                                            const selectedIds = event.map(Number);
                                                            const selectedNames = selectedIds.map(
                                                                id => tagOptions.find(option => option.value === id)?.text || ''
                                                            );
                                                            setFormData({
                                                                ...formData,
                                                                feeStageTags: selectedIds,
                                                                feeStageTagDescriptions: selectedNames
                                                            })
                                                        }}
                                                        label="Fee Stage Tags"
                                                        options={tagOptions}
                                                        requiredLabel
                                                        required={false}
                                                        sx={{ height: '35px', backgroundColor: "#fff" }}
                                                    />
                                                </Grid2>

                                                {formData.stageAreaDescription.toLocaleUpperCase() === 'SORAT' && (
                                                    <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                        <Typography sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1, mt: 1 }}>
                                                            Completed by India SORAT Team
                                                        </Typography>
                                                        <Grid2 sx={{ display: 'flex', mb: 1 }}> {/* Adjust gap as needed */}
                                                            {/* Custom Radio Buttons */}
                                                            <CustomRadioButton
                                                                label="Yes"
                                                                value="true"
                                                                name="isIndia"
                                                                checked={formData.isIndia}
                                                                onChange={handleChange}
                                                                required={true}
                                                            />
                                                            <CustomRadioButton
                                                                label="No"
                                                                value="false"
                                                                name="isIndia"
                                                                checked={!formData.isIndia}
                                                                onChange={handleChange}
                                                                required={true}
                                                            />
                                                        </Grid2>
                                                    </Grid2>
                                                )}

                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <Typography sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1, mt: 1 }}>Is Disbursement</Typography>
                                                    <Grid2 sx={{ display: 'flex', mb: 1 }}> {/* Adjust gap as needed */}
                                                        {/* Custom Radio Buttons */}
                                                        <CustomRadioButton
                                                            label="Yes"
                                                            value="true"
                                                            name="isDisbursement"
                                                            checked={formData.isDisbursement}
                                                            onChange={handleChange}
                                                            required={true}
                                                        />
                                                        <CustomRadioButton
                                                            label="No"
                                                            value="false"
                                                            name="isDisbursement"
                                                            checked={!formData.isDisbursement}
                                                            onChange={handleChange}
                                                            required={true}
                                                        />
                                                    </Grid2>
                                                </Grid2>

                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <Typography sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1, mt: 1 }}>Status</Typography>
                                                    <Grid2 sx={{ display: 'flex', mb: 1 }}> {/* Adjust gap as needed */}
                                                        {/* Custom Radio Buttons */}
                                                        <CustomRadioButton
                                                            label="Active"
                                                            value="true"
                                                            name="status"
                                                            checked={formData.status}
                                                            onChange={handleChange}
                                                            required={true}
                                                        />
                                                        <CustomRadioButton
                                                            label="Inactive"
                                                            value="false"
                                                            name="status"
                                                            checked={!formData.status}
                                                            onChange={handleChange}
                                                            required={true}
                                                            disabled
                                                        />
                                                    </Grid2>
                                                </Grid2>

                                                <Grid2 size={{ xs: 6, md: 3, lg: 3 }}>
                                                    <Typography sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1, mt: 1 }}>Third Party Cost</Typography>
                                                    <Grid2 sx={{ display: 'flex', mb: 1 }}>
                                                        {/* Custom Radio Buttons */}
                                                        <CustomRadioButton
                                                            label="Yes"
                                                            value="true"
                                                            name="isThirdPartyCost"
                                                            checked={formData.isThirdPartyCost}
                                                            onChange={handleChange}
                                                            required={true}
                                                            disabled={formData.feeStageValue < 0}
                                                        />
                                                        <CustomRadioButton
                                                            label="No"
                                                            value="false"
                                                            name="isThirdPartyCost"
                                                            checked={!formData.isThirdPartyCost}
                                                            onChange={handleChange}
                                                            required={true}
                                                        />
                                                    </Grid2>

                                                    {/* Conditionally show textbox when "Yes" is selected */}
                                                    {formData.isThirdPartyCost && formData.feeStageValue > 0 && (
                                                        <>
                                                            <CustomTextField
                                                                name="thirdPartyCost"
                                                                //value={formData.thirdPartyCost}
                                                                value={formData.thirdPartyCost ? formatNumberWithCommas(formData.thirdPartyCost) : ''}
                                                                onChange={handleChange}
                                                                sx={{ mb: 1, backgroundColor: "#fff" }}
                                                            />
                                                            {errors.thirdPartyCost && (
                                                                <Typography className="validationMessage" role="alert">
                                                                    {errors.thirdPartyCost}
                                                                </Typography>
                                                            )}
                                                        </>
                                                    )}

                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomDropdown
                                                        value={formData.categoryId}
                                                        onChange={(event) => {
                                                            const selectedId = Number(event.target.value);
                                                            const selectedOption = categoryOptions.find(option => option.value === selectedId)
                                                            setFormData({
                                                                ...formData,
                                                                categoryId: selectedId,
                                                                categoryName: selectedOption?.text!
                                                            })
                                                            fetchSubCategory(selectedId)
                                                        }}
                                                        label="Category"
                                                        requiredLabel
                                                        required={false}
                                                        options={categoryOptions}
                                                        sx={{ mb: 1, height: '35px', backgroundColor: "#fff" }}
                                                    />
                                                </Grid2>


                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomDropdown
                                                        value={formData.subCategoryId}
                                                        onChange={(event) => {
                                                            const selectedId = Number(event.target.value);
                                                            const selectedOption = subCategoryOptions.find(option => option.value === selectedId)
                                                            setFormData({
                                                                ...formData,
                                                                subCategoryId: selectedId,
                                                                subCategoryName: selectedOption?.text!
                                                            })
                                                        }}
                                                        label="Sub Category"
                                                        requiredLabel
                                                        required={false}
                                                        options={subCategoryOptions}
                                                        sx={{ mb: 1, height: '35px', backgroundColor: "#fff" }}
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomTextField
                                                        label="Terms and Notes"
                                                        name="termsNotesComments"
                                                        value={formData.termsNotesComments}
                                                        onChange={handleChange}
                                                        sx={{ mb: 1, backgroundColor: "#fff" }}
                                                        isTextArea
                                                    />
                                                </Grid2>

                                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                                    <CustomDropdown
                                                        value={formData.feeStageStaus}
                                                        onChange={(event) => {
                                                            const selectedId = Number(event.target.value);
                                                            const selectedOption = statusOptions.find(option => option.value === selectedId)
                                                            setFormData({
                                                                ...formData,
                                                                feeStageStaus: selectedId,
                                                                stageStatusDescription: selectedOption?.text!
                                                            })
                                                        }}
                                                        label="Fee Stage Status"
                                                        requiredLabel
                                                        required={false}
                                                        options={statusOptions}
                                                        sx={{ mb: 1, height: '35px', backgroundColor: "#fff" }}
                                                    />
                                                </Grid2>
                                            </Grid2>
                                            <Toaster open={toast.open} message={toast.message} type={toast.type as "success" | "error"} onClose={() => setToast({ ...toast, open: false })} />
                                        </>
                                    )
                                case 2:
                                    return <ProposalFeeStageSummary />;
                                case 4:
                                    return <ProposalFeeStageCommercialDates />
                                case 5:
                                    return <ProposalFeeStageNotesComments />
                                case 6:
                                    return <ProposalFeeStageInstructionLog />;
                                case 7:
                                    return <ProposalFeeStageSubStage/>;

                                default:
                                    return null;
                            }
                        })()
                    }

                </Box>
            </Box>

        </AppLayout>

    );
};

export default ProposalEditFeeStage;